import React, { useState, useEffect, useCallback } from 'react';
import { api } from '@/contexts/AuthContext';
import { UserCheck, X } from 'lucide-react';

export const ProjectSupervisors = ({ projectId, canManage }) => {
  const [data, setData] = useState({ assigned: [], available: [] });
  const [selected, setSelected] = useState('');

  const load = useCallback(() => {
    api.get(`/projects/${projectId}/supervisors`).then(r => setData(r.data)).catch(() => {});
  }, [projectId]);
  useEffect(() => { load(); }, [load]);

  const act = async (method, userId) => {
    try {
      await api[method](`/projects/${projectId}/supervisors/${userId}`);
      setSelected('');
      load();
    } catch (err) { alert(err.response?.data?.detail || 'Action failed'); }
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-5 mb-4" data-testid="project-supervisors">
      <h3 className="text-sm font-semibold text-slate-900 mb-1">Site Supervisors</h3>
      <p className="text-xs text-slate-500 mb-4">Assigned Supervisors see this project and can file DWRs for it.</p>
      {canManage && (
        <div className="flex flex-col sm:flex-row gap-2 mb-4">
          <select value={selected} onChange={e => setSelected(e.target.value)} className="input-field flex-1" data-testid="supervisor-assign-select">
            <option value="">Select a Supervisor</option>
            {data.available.map(s => <option key={s.id} value={s.id}>{s.name} ({s.email})</option>)}
          </select>
          <button onClick={() => act('post', selected)} disabled={!selected} data-testid="supervisor-assign-btn"
            className="bg-[#1B5486] text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-[#144066] disabled:opacity-50">Assign</button>
        </div>
      )}
      {data.assigned.length === 0 ? (
        <div className="text-center py-4 text-sm text-slate-400" data-testid="no-supervisors">No Supervisors assigned</div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {data.assigned.map(s => (
            <span key={s.id} className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#1B5486]/5 border border-[#1B5486]/20 text-sm text-[#1B5486]" data-testid={`assigned-supervisor-${s.id}`}>
              <UserCheck size={14} /> {s.name}
              {canManage && (
                <button onClick={() => window.confirm(`Remove ${s.name} from this project?`) && act('delete', s.id)} className="text-slate-400 hover:text-red-500" title="Remove" data-testid={`remove-supervisor-${s.id}`}><X size={14} /></button>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
